import { styled } from "styled-components";

function AuthorBox(props) {
  return (
    <Author>
      <div>
        <ProfilePic>
          {props.photo ? (
            <img src={props.photo} alt="" />
          ) : (
            props.name.substr(0, 2)
          )}
        </ProfilePic>
      </div>
      <div>
        <small>Written by:</small>
        <Name>{props.name}</Name>
      </div>
    </Author>
  );
}

export default AuthorBox;

const Author = styled.section`
  display: flex;
  align-items: center;
  small {
    font-size: 12px;
  }
`;

const ProfilePic = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: #ccc;
  border: 2px solid #ccc;
  overflow: hidden;
  margin-right: 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: #eee;
  img {
    width: 40px;
  }
`;

const Name = styled.p`
  color: rgb(4, 115, 234);
  font-weight: 500;
  font-size: 14px;
  line-height: 20px !important;
  margin-bottom: 0 !important;
`;
